import { ContentService } from '@blk/cwp-ng-framework';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';

import { Formatter } from './formatter.interface';

dayjs.extend(utc);

export class ISODateFormatter implements Formatter {
	public static readonly SHORT: Intl.DateTimeFormatOptions = { timeZone: 'UTC', year: '2-digit', month: 'numeric', day: 'numeric' };
	public static readonly FULL: Intl.DateTimeFormatOptions = { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric' };
	public static readonly LOCALE_M_DD_YYYY: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'numeric', day: '2-digit' };

	constructor(private options: Intl.DateTimeFormatOptions = ISODateFormatter.FULL, private shouldRemoveTimezone = false) { }
	public format(value: any, contentSvc?: ContentService): string {
		if (value) {
			switch (typeof value) {
				case 'number':
					return new Date(value).toLocaleDateString('en-US', this.options).replace(/\u200E/g, '');
				case 'string':
					if (this.shouldRemoveTimezone && value.includes('T')) {
						value = value.split('T')[0];
					}

					const dayjsDate = dayjs(value).utc(true).valueOf();
					if (!!dayjsDate) {
						return new Date(dayjsDate).toLocaleDateString('en-US', this.options).replace(/\u200E/g, '');
					} else {
						return value;
					}
				default:
					return value;
			}
		} else {
			return value;
		}
	}
}
